import { gql } from '@/__generated__';

export const GET_GATE_RENDERER_DATA = gql(`#graphql
  query GetGateRendererData($gateId: ID!) {
    gate(input: { id: $gateId }) {
      id
      mainDevice {
        id
      }
      movements2 {
        id
        activeMovement {
          ...GateMovementFragment
        }
        lastMovement {
          ...GateMovementFragment
        }
        lastPosition
        lastBattery
        unit
        precision
        history {
          ...GateMovementFragment
        }
        operatingState
      }
    }
  }
`);
